export default {
  cards: [
    {
      name: "Rotghoul",
      attack: 5,
      defense: 5,
      health: 10,
      race: "spirit",
      specialDesc: "50% to attack twice in a turn.",
      specialEffect: "DoubleAttack",
      cost: 6,
      deployReady: false,
      fightReady: false,
      image: "rotghoul.svg",
    },
    {
      name: "AncientKeeper",
      attack: 2,
      defense: 2,
      health: 7,
      race: "spirit",
      specialDesc: "Revives a random monster from a graveyard.",
      specialEffect: "ReviveRandom",
      cost: 5,
      deployReady: false,
      fightReady: false,
      image: "monster.svg",
    },
    {
      name: "NightHunter",
      attack: 10,
      defense: 10,
      health: 20,
      race: "spirit",
      specialDesc: "Gets 1 attack for every deployed monster.",
      specialEffect: "AttackBuffPassive",
      cost: 10,
      deployReady: false,
      fightReady: false,
      image: "demon.svg",
    },
    {
      name: "Emberfang",
      attack: 7,
      defense: 3,
      health: 7,
      race: "spirit",
      cost: 3,
      deployReady: false,
      fightReady: false,
      image: "emberfang.svg",
    },
    {
      name: "Vexmirage",
      attack: 3,
      defense: 15,
      health: 15,
      race: "spirit",
      cost: 5,
      deployReady: false,
      fightReady: false,
      image: "vexmirage.svg",
    },
    {
      name: "The Lonely Herder",
      attack: 12,
      defense: 4,
      health: 10,
      race: "beast",
      specialDesc: "Gets one attack for every enemy slayed.",
      specialEffect: "AttackBuffActive",
      cost: 8,
      deployReady: false,
      fightReady: false,
      image: "gargoyle.svg",
    },
    {
      name: "Dreambrood",
      attack: 2,
      defense: 8,
      health: 15,
      race: "beast",
      specialDesc: "Summons a random monster from the deck.",
      specialEffect: "SummonsRandomCard",
      cost: 5,
      deployReady: false,
      fightReady: false,
      image: "dreambrood.svg",
    },
    {
      name: "The Crazed Nether Buffalo",
      attack: 10,
      defense: 10,
      health: 15,
      race: "beast",
      specialDesc: "Gets +10 defense if health falls bellow 7.",
      specialEffect: "SelfDefenseBuff",
      cost: 10,
      deployReady: false,
      fightReady: false,
      image: "crazednether.svg",
    },
    {
      name: "Mistbeast",
      attack: 3,
      defense: 3,
      health: 3,
      race: "beast",
      cost: 2,
      deployReady: false,
      fightReady: false,
      image: "cthulhu.svg",
    },
    {
      name: "Hellwing",
      attack: 5,
      defense: 5,
      health: 10,
      race: "beast",
      cost: 5,
      deployReady: false,
      fightReady: false,
      image: "hellwing.svg",
    },
  ],
};
